import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-frameboard',
  templateUrl: './frameboard.component.html',
  styleUrls: ['./frameboard.component.scss']
})
export class FrameboardComponent implements OnInit {

  @Output() onShowFilter = new EventEmitter()

  agregarClase = false;
  despacho = false;
  enviados = false;
  carta = false;
  sistram = false;
  prestamos = false;
  archivados = false;
  reportes = false;
  fedatario = false;
  alertas = false;
  general = false;
  reasignacion = false;

  bandeja: any;



    constructor(private route: ActivatedRoute, private router: Router,
    @Inject(DOCUMENT) private DomURL: Document
  ) {

  }

  ngOnInit(): void {
    this.rutas();

    if ( localStorage.getItem('bandeja')) {
      this.bandeja = JSON.parse(localStorage.getItem('bandeja'));
    }
  }

  open() {
    var element = document.getElementById("navcontrol");
    element.classList.toggle("open");
  }

  rutas() {

    const rutaAnterior = this.DomURL.location.href
    const rutanuevo = rutaAnterior.split('/').find(
      (url) => {
        if (url === 'bandeja') {
          this.agregarClase = true
        }
        if (url === 'despacho') {
          this.despacho = true
        }
        if (url === 'enviados') {
          this.enviados = true
        }
        if (url === 'archivados') {
          this.archivados = true
        }
        if (url === 'reportes') {
            this.reportes = true
        }
        if (url === 'fedatarios') {
            this.fedatario = true
        }
        if (url === 'alertas') {
            this.alertas = true;
        }
        if (url === 'carpetas') {
          this.carta = true
        }
        if (url === 'sistram') {
          this.sistram = true
        }
          if (url === 'reasignacion') {
              this.reasignacion = true
          }
          if (url === 'prestamos') {
              this.prestamos = true
          }
      }
    )
      if ( rutaAnterior.includes('/general/') ) {
          this.general = true;
      }
  }

    redirectSameRoute() {
        const currentRoute = this.router.url;
        const targetRoute = '/usuario-final/reasignacion'
        if ( currentRoute === targetRoute) {
            this.router.navigateByUrl('/', {skipLocationChange: true})
                .then(() => this.router.navigateByUrl(currentRoute));
        }
    }

}
